import { render, staticRenderFns } from "./TheSidebarRight.vue?vue&type=template&id=4f85bdfb&scoped=true&"
import script from "./TheSidebarRight.vue?vue&type=script&lang=js&"
export * from "./TheSidebarRight.vue?vue&type=script&lang=js&"
import style0 from "./TheSidebarRight.vue?vue&type=style&index=0&id=4f85bdfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f85bdfb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDivider,VIcon,VListItem,VListItemAction,VListItemContent,VListItemSubtitle,VNavigationDrawer,VSwitch,VTooltip})
